module.exports = __webpack_public_path__ + "static/media/frames-22.1f0d840f.jpg";